import { render, staticRenderFns } from "./SectionKpiCards.vue?vue&type=template&id=24f51188&scoped=true"
import script from "./SectionKpiCards.vue?vue&type=script&lang=ts"
export * from "./SectionKpiCards.vue?vue&type=script&lang=ts"
import style0 from "./SectionKpiCards.vue?vue&type=style&index=0&id=24f51188&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f51188",
  null
  
)

export default component.exports